import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/qroll/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={926}
              height={862}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#644BB1" }}>Solution</span>
            </h2>
            <p>
              With the help of our innovative app designers and developers, we
              have built an app that is engaging and easy to navigate.
            </p>
            <p>
              Models, photographers, makeup artists and other people of talents
              can create their online profile and connect with people who seek
              their services.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
